import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumHL } from 'components/global/utils';
import { UndeliveredGridData } from '@pages/reporting-pages/undelivered-orders/types/UndeliveredGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
}


const GridSummary = (props: GridSummaryProps<UndeliveredGridData>) => {
	const { data } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'orderSentVolume', 2)}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'orderSentCount')}</p>
			</div>
		</>
	)
}

export default GridSummary;